import defaultItems from '../../../../../common/defaultItems';

export default function () {
    return {
        index: '',
        type: 'STATIC_BLOCK',
        title: 'Image Text Columns',
        thumbnailUrl: null,
        content: {
            columnNum: 3,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#ffffff',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '',
                    size: 1 / 3,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'IMAGE',
                            content: {
                                ...defaultItems.IMAGE.content,
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                textMarkupValue:
                                    '<p><strong>Tip:</strong> Find a way to help employees relate to the content. Show them how it affects them personally. Use emotion or storytelling to give it heart and context, and you’ll have people reading in no time.</p>',
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'BUTTON',
                            content: defaultItems.BUTTON.content,
                        },
                    ],
                },
                {
                    columnIdx: '',
                    size: 1 / 3,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'IMAGE',
                            content: {
                                ...defaultItems.IMAGE.content,
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                textMarkupValue:
                                    '<p><strong>Tip:</strong> Find a way to help employees relate to the content. Show them how it affects them personally. Use emotion or storytelling to give it heart and context, and you’ll have people reading in no time.</p>',
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'BUTTON',
                            content: defaultItems.BUTTON.content,
                        },
                    ],
                },
                {
                    columnIdx: '',
                    size: 1 / 3,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'IMAGE',
                            content: {
                                ...defaultItems.IMAGE.content,
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                textMarkupValue:
                                    '<p><strong>Tip:</strong> Find a way to help employees relate to the content. Show them how it affects them personally. Use emotion or storytelling to give it heart and context, and you’ll have people reading in no time.</p>',
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'BUTTON',
                            content: defaultItems.BUTTON.content,
                        },
                    ],
                },
            ],
        },
    };
}
